import { DSDatepicker, DSText } from '@vr/ds-react'
import { Controller } from 'react-hook-form'

type DeliveryDateProps = {
  methods: any
  accountKey: number
}

export const DeliveryDate = ({ methods, accountKey }: DeliveryDateProps) => {
  return (
    <>
      <Controller
        key={accountKey}
        name='dataDaEntrega'
        control={methods.control}
        rules={{
          required: 'Data de entrega é obrigatório'
        }}
        render={({ field: { onChange, value } }) => (
          <DSDatepicker
            label='Data de entrega*'
            name='dataDaEntrega'
            onChange={date => {
              onChange(date?.value ?? null)
            }}
            value={value}
          />
        )}
      />
      {typeof methods.formState.errors.dataDaEntrega?.message === 'string' && (
        <DSText as='span' size='sm' weight='semibold' color='errorLight'>
          {methods.formState.errors.dataDaEntrega.message}
        </DSText>
      )}
    </>
  )
}
